<section>
    <div class="blogsDiv" *ngIf="blogdata!=undefined">
        <div class="spinner" *ngIf="spinner">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <h1 class="title text-center">Blogs</h1>
        <div class="row mt-5 desk_contanier">
            <div class="col-md-4 d-flex justify-content-center align-items-center" *ngFor="let item of blogdata ;let i=index">
                <div class="profile_content">
                    <div class="img_content">
                        <img src={{item.files[0].url}} loading="lazy" width="100%" class="img" alt={{item.files[0].filename}}>
                    </div>
                    <div class="profile_text">
                        <div class="infoContent">
                            <div class="date">{{item.FromDate}}</div>
                            <div class="text1">{{item.Title}}</div>
                            <div class="para">
                                <div class="box">
                                    <input type="checkbox" id="{{i}}">
                                    <p>{{item.Short}}</p>
                                </div>
                                <a class="" role="button" routerLink="/blog/{{item.slug}}"><button
                                        class="btn readMoreBtn">Read More</button></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mobile_res_content">
              <div id="carousel1" class="owl-carousel owl-theme">
                <div class="item" [ngClass]="(i === 0) ? 'active' : ''" data-bs-interval="10000" *ngFor="let item of blogdata ;let i=index">
                    <div class="profile_content">
                        <div class="img_content">
                            <img src={{item.files[0].url}} loading="lazy" width="100%" class="img" alt={{item.files[0].filename}}>
                        </div>
                        <div class="profile_text">
                            <div class="infoContent">
                                <div class="date">{{item.FromDate}}</div>
                                <div class="text1">{{item.Title}}</div>
                                <div class="para">
                                    <div class="box">
                                        <input type="checkbox" id="{{i}}">
                                        <p>{{item.Short}}</p>
                                    </div>
                                    <a class="" role="button" routerLink="/blog/{{item.slug}}"><button
                                            class="btn readMoreBtn">Read More</button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
              </div>
        </div>
    </div>
</section>